import React,{useState} from 'react'
import { useSupabase } from '../context/SupabaseContext';
import {
    Badge,
    Modal,
    Button,
    Card,
    Form,
    ProgressBar,
    Container,
    Row,
    Col,
  } from "react-bootstrap";

export default function modelScan(props) {
  const { addTransaction } = useSupabase();
  const [newName, setNewName] = useState("");
  const [newCategory, setNewCategory] = useState("");
  // const [newAmount, setNewAmount] = useState(props.amount);
  const [newDate, setNewDate] = useState("");
  const [newPaymentMode, setNewPaymentMode] = useState("");
  
  const newTransaction = async (e) => {
    e.preventDefault()
    console.log('Form submission started');
    
    // Validate required fields
    if (!newName || !newCategory || !newDate || !newPaymentMode) {
      console.log('Validation failed - missing fields:', { newName, newCategory, newDate, newPaymentMode });
      alert('Please fill all required fields');
      return;
    }
    
    // Format date properly
    const formattedDate = newDate instanceof Date ? newDate.toISOString().split('T')[0] : newDate;
    
    const transactionData = {
      name: newName,
      category: newCategory,
      amount: props.amount || 0,
      date: formattedDate,
      payment_mode: newPaymentMode,
      type: 'expense'
    }
    
    console.log('Submitting transaction:', transactionData);
    
    try {
      console.log('Calling addTransaction...');
      const result = await addTransaction(transactionData);
      console.log('Transaction result received:', result);
      
      if (result && result.success) {
        console.log('Transaction added successfully');
        alert('Transaction added successfully!');
        
        // Close modal first
        if (props.closeModel) {
          console.log('Closing modal...');
          props.closeModel()
        }
        
        // Then fetch data
        if (props.fetchData) {
          console.log('Fetching updated data...');
          await props.fetchData()
        }
        
        // Reset form
        setNewName("");
        setNewCategory("");
        setNewDate("");
        setNewPaymentMode("");
      } else {
        console.log('Transaction failed - no success flag');
        alert('Failed to add transaction: ' + (result.error || 'Unknown error'));
      }
    } catch (e) {
      console.error('Error adding transaction:', e);
      alert('Error adding transaction: ' + e.message);
    }
  }

    return (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton>
                <span className="h3 b2">Add New Transaction</span>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={newTransaction}>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Row>
                  <Col>
                    <Form.Control placeholder="Name of the Transaction"
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                      required
                    ></Form.Control>
                  </Col>
                </Form.Row>
              </Form.Group>
              <Form.Row>
                <Form.Group as={Col} controlId="formGridNum">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter the Amount"
                    value={props.amount}
                    // onChange={(e) => setNewAmount(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="formGridCat">
                  <Form.Label>Category</Form.Label>
                  <Form.Control as="select"
                    onChange={(e) => setNewCategory(e.target.value)}
                    required
                  >
                    <option value="">Choose...</option>
                    <option value="Household">Household</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Fashion">Fashion</option>
                    <option value="Sports and Fitness">Sports and Fitness</option>
                    <option value="Automobile">Automobile</option>
                    <option value="Baby Care">Baby Care</option>
                    <option value="Others">Others</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Mode of Payment</Form.Label>
                  <Form.Control as="select"
                    onChange={(e) => setNewPaymentMode(e.target.value)}
                    required
                  >
                    <option value="">Choose...</option>
                    <option value="credit card">Credit Card</option>
                    <option value="debit card">Debit Card</option>
                    <option value="cash">Cash</option>
                    <option value="bitcoin">Bitcoin</option>
                    <option value="UPI">UPI</option>
                    <option value="net banking">Net Banking</option>
                    <option value="others">Others</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group>
                  <label>Date</label>
                  <Form.Control
                    placeholder="Date"
                    type="date"
                    value={newDate}
                    onChange={e => setNewDate(e.target.value)}
                    required
                  ></Form.Control>
                </Form.Group>
              </Form.Row>
              <div className="d-flex justify-content-end">
                <Button  className="btn-fill" variant="success" 
                type="submit"
              >
                Add Transaction
              </Button>
                <Button  className="btn-fill ml-2" variant="info" 
                  onClick={props.closeModel}
                >
                  Close
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
    )
}
